import React from 'react';
import qwest from 'qwest';

const helper = {
  getReportLink(id, locale) {
    let url = `/ReportLink/ReportLink?reportID=${id}`;

    if (locale) {
      url += `&locale=${locale}`;
    }

    return qwest.get(url);
  },
  getSeasonUsageLink(id, locale) {
    let url = `/ReportLink/SeasonUsageLink?poolID=${id}`;

    if (locale) {
      url += `&locale=${locale}`;
    }

    return qwest.get(url);
  },
};

export default helper;
